import { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { getCommerceWhatsAppService } from "modules/jarvis/services/whatsappService";
import { filterWhatsapp, whatsappFilters, whatsappStats } from "../model/whatsappModel";

export const useWhatsappJarvis = () => {
  const [rows, setRows] = useState([]),
    [loading, setLoading] = useState(true),
    [error, setError] = useState(null),
    [lastUpdated, setLastUpdated] = useState(null),
    [filtros, setFiltros] = useState(whatsappFilters);
  const mounted = useRef(false),
    revision = useRef(0),
    pending = useRef(null);
  const loadConfiguraciones = useCallback(async () => {
    pending.current?.abort();
    const controller = new AbortController();
    pending.current = controller;
    const request = ++revision.current;
    setLoading(true);
    setError(null);
    try {
      const result = await getCommerceWhatsAppService({ signal: controller.signal });
      if (!mounted.current || request !== revision.current) return null;
      if (result.success) {
        setRows(result.data);
        setLastUpdated(new Date().toISOString());
      } else setError(result.error);
      return result;
    } catch (err) {
      if (!mounted.current || request !== revision.current) return null;
      setError(err.message);
      return { success: false, error: err.message };
    } finally {
      if (mounted.current && request === revision.current) {
        setLoading(false);
        pending.current = null;
      }
    }
  }, []);
  useEffect(() => {
    mounted.current = true;
    loadConfiguraciones();
    return () => {
      mounted.current = false;
      revision.current += 1;
      pending.current?.abort();
    };
  }, [loadConfiguraciones]);
  const configuraciones = useMemo(() => filterWhatsapp(rows, filtros), [rows, filtros]);
  const stats = useMemo(() => whatsappStats(configuraciones), [configuraciones]);
  const gruposNOC = useMemo(
    () => [...new Set(rows.map((row) => row.grupoAlertaNOC).filter(Boolean))].sort(),
    [rows]
  );
  const setFiltro = useCallback(
    (key, value) => setFiltros((prev) => ({ ...prev, [key]: value })),
    []
  );
  const clearFilters = useCallback(() => setFiltros(whatsappFilters), []);
  return {
    configuraciones,
    todasConfiguraciones: rows,
    loading,
    error,
    lastUpdated,
    filtros,
    stats,
    gruposNOC,
    loadConfiguraciones,
    refreshData: loadConfiguraciones,
    setFiltro,
    clearFilters,
  };
};
